import $ from "jquery";

import { BACKEND_CONFIG } from "../../config/consts";

export const createClientsTableDataSource = (
  clientsData,
  users,
  uaUrl,
  settings
) => {
  var clients = [];

  for (var i = 0; i < clientsData.length; i++) {
    var client = createClient(clientsData[i], users, uaUrl, settings);

    clients.push(client);
  }

  return clients;
};

const createClient = (clientsData, users, uaUrl, settings) => {
  var client = {};

  client.uaUrl = uaUrl;
  client.id = clientsData.Id;
  client.archived = clientsData.Archived;
  client.businessName = clientsData.BusinessName || "";
  client.primaryContactPhone = clientsData.PrimaryContactPhone;
  client.producerId = clientsData.AgencyUserId;
  client.hasInForcePolicies = clientsData.HasInForcePolicies;
  client.hasProposedQuotes = clientsData.HasProposedQuotes;
  client.clientId = clientsData.ClientId;
  client.earliestExpirationDate = clientsData.EarliestExpirationDate;
  client.submittedDate = getSubmittedDate(clientsData);
  client.lastQuotedDate = clientsData.LastQuotedDate || "";
  client.activePoliciesCount = clientsData.ActivePoliciesCount;
  client.expiredPoliciesCount = clientsData.ExpiredPoliciesCount;
  client.accountSize =
    "$" +
    clientsData.AccountSize.toLocaleString(undefined, {
      maximumFractionDigits: 2,
    });
  client._submitted = clientsData.Submitted;
  client.uaClientCreatedOn = clientsData.UaClientCreatedOn;
  client.status = clientsData.Status;
  client.busClass = clientsData.BusClass || "";
  client.isNotPreSubmittedProspect = clientsData.IsNotPreSubmittedProspect;
  client.users = users;
  client.endTableBtn = createEndTableButtonCallback(clientsData, uaUrl);
  client.businessNameRedirectToApp = createBusinessNameRedirectToApp(
    clientsData,
    uaUrl
  );
  if (settings && settings.allowProducerDropDown) {
    client.producer = createProducerCallback(clientsData, users);
  } else {
    client.producer = clientsData.Producer;
  }
  client.selectedProducerName = getUserSelectName(
    users.filter((user) => user.Id === clientsData.AgencyUserId)[0]
  );

  if (
    !clientsData.HasInForcePolicies ||
    !clientsData.IsNotPreSubmittedProspect
  ) {
    client.actions = client.endTableBtn;
    return client;
  }

  client.actions = createActionsCallback(clientsData);
  return client;
};

const getSubmittedDate = (clientsData) => {
  var submittedDate = clientsData.SubmittedDate;

  if (
    !clientsData.Submitted ||
    !clientsData.IsNotPreSubmittedProspect ||
    !submittedDate
  ) {
    return "";
  }

  return submittedDate;
};

const createEndTableButtonCallback = (clientData, uaUrl) => {
  return function () {
    if (clientData.IsNotPreSubmittedProspect) {
      return (
        '<a href="/client/' +
        clientData.Id +
        '" class="btn btn-primary w-90px">View Details</a>'
      );
    }
    var submitLink = uaUrl + "api/primary_ua/resume/" + clientData.Id;

    return (
      "<form action=" +
      submitLink +
      ' method="post">' +
      '<input type="hidden" name="token" value=' +
      BACKEND_CONFIG.get("auth") +
      "></input>" +
      '<button class="btn btn-primary w-90px finish-app-btn" type="submit">Finish App</button>' +
      "</form>"
    );
  };
};

const createBusinessNameRedirectToApp = (clientData, uaUrl) => {
  return function () {
    if (clientData.BusinessName) {
      return (
        "<a target='_top' href='" +
        uaUrl +
        "Login?clientId=" +
        clientData.Id +
        "&bearer=" +
        BACKEND_CONFIG.get("auth") +
        "'>" +
        clientData.BusinessName +
        "</a>"
      );
    }

    return "";
  };
};

const createActionsCallback = (clientsData) => {
  var id = clientsData.Id;

  return function () {
    var result =
      '<div class="dropdown" id="action-dd">' +
      '<button type="button" class="btn btn-default dropdown-toggle w-90px pl-0" data-boundary="action-dd" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>' +
      '<ul class="dropdown-menu dropdown-menu-right">' +
      "<li>" +
      '<a data-toggle="modal" href="/client/' +
      id +
      '" class="btn-view-details" data-clientid="' +
      clientsData.ClientId +
      '">View Details</a>' +
      "</li>";

    if (clientsData.UaClientCreatedOn) {
      result +=
        '<li><a  href="/client/' +
        id +
        "/request-quote-change/" +
        '" >Request Quote Change</a></li>' +
        '<li><a href="client/' +
        id +
        "/documents/" +
        '">Policy Documents</a></li>' +
        '<li><a href="/reference-tools/carrier">How to Submit a Claim</a></li>';
    }

    return result + "</ul></div>";
  };
};

const createProducerCallback = (clientData, users) => {
  return function () {
    var userSelect =
      '<div class="dropdown as-select col-fw-170px" id="changeUser">' +
      '<button type="button" class="btn btn-default dropdown-toggle w-100 text-truncate text-left" data-boundary="changeUser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-clientid="' +
      clientData.Id +
      '">' +
      '<span id="content" class="filter-option text-truncate">' +
      getSelectUserName(clientData, users) +
      "</span>" +
      "</button>" +
      '<ul class="dropdown-menu" style="width: auto;min-width: 220px;">';

    for (var i = 0; i < users.length; i++) {
      var user = users[i];
      var userId = user.Id;
      var name = getUserSelectName(user);

      userSelect +=
        '<li id="ddlAgencyUser" class="dropdown-item" style="cursor:pointer" ' +
        (userId === clientData.AgencyUserId ? "selected " : "") +
        'value="' +
        userId +
        '">' +
        name +
        "</li>";

      if (userId === clientData.AgencyUserId) {
        $(userSelect).closest("> span.filter-option").text(name);
      }
    }

    return userSelect;
  };
};

const getSelectUserName = (clientData, users) => {
  var selectedUser = users.filter((u) => u.Id === clientData.AgencyUserId)[0];

  return selectedUser ? getUserSelectName(selectedUser) : "";
};

const getUserSelectName = (user) => {
  if (!user) {
    return "";
  }

  return ((user.FirstName || "") + " " + (user.LastName || "")).trim();
};
